import React from 'react';
import { FormField, FormFieldLabel, FormFieldValue } from 'styles/common.styles';

/**
 * Select ?�???�드 컴포?�트
 * 
 * @param {Object} props
 * @param {string} props.name - ?�드 ?�름
 * @param {string} props.label - ?�드 ?�벨
 * @param {string} props.value - ?�드 �? * @param {Array} props.options - ?�션 배열 [{ value, label }] ?�는 [string]
 * @param {string} props.width - ?�드 ?�비
 * @param {string} props.itemWidth - select ?�소 ?�비
 * @param {string} props.labelWidth - ?�벨 ?�비
 * @param {string} props.fieldWidth - FormField ?�체 ?�비
 * @param {boolean} props.readonly - ?�기 ?�용 ?��?
 * @param {Function} props.onChange - �?변�??�들?? * @param {Object} props.fieldProps - 추�? ?�드 ?�성
 */
const SelectField = ({
  name,
  label,
  value = '',
  options = [],
  width,
  labelWidth,
  fieldWidth,
  showColon = false,
  readonly = false,
  onChange,
  fieldProps = {},
}) => {
  return (
    <FormField
      width={fieldWidth || 'auto'}
    >
      {label && (
        <FormFieldLabel width={labelWidth} >{showColon ? `${label}:` : label}</FormFieldLabel>
      )}
      <FormFieldValue
        as="select"
        name={name}
        value={value}
        disabled={readonly}
        onChange={readonly ? undefined : onChange}
        width={width || 'auto'}
        {...fieldProps}
      >
        {options.map((option) => {
          // options가 { value, label } ?�태??경우
          if (typeof option === 'object' && option.value !== undefined) {
            return (
              <option key={option.value} value={option.value}>
                {option.label}
              </option>
            );
          }
          // options가 문자??배열??경우
          return (
            <option key={option} value={option}>
              {option}
            </option>
          );
        })}
      </FormFieldValue>
    </FormField>
  );
};

export default SelectField;

